<template>
  <div class="mb-4">
    <h3>Create new account</h3>
  </div>
  <form autocomplete="off" onsubmit="event.preventDefault();">
    <div>
      <label>Username</label>
      <input class="form-control" v-model="signUpForm.loginValue" type="text" placeholder="Username"
        :class="{ 'border-danger': signUpForm.errors.loginValue }" />
      <div class="msg-error" v-if="signUpForm.errors.loginValue">{{ signUpForm.errors.loginValue }}</div>
    </div>

    <div class="mt-3">
      <label>Password</label>
      <input class="form-control" v-model="signUpForm.password" type="password" placeholder="Password"
        :class="{ 'border-danger': signUpForm.errors.password }" />
      <div class="msg-error" v-if="signUpForm.errors.password">{{ signUpForm.errors.password }}</div>
    </div>

    <div class="mt-3">
      <label>Confirm password</label>
      <input class="form-control" v-model="signUpForm.confirmPassword" type="password" placeholder="Confirm password"
        :class="{ 'border-danger': signUpForm.errors.confirmPassword }" />
      <div class="msg-error" v-if="signUpForm.errors.confirmPassword">{{ signUpForm.errors.confirmPassword
      }}</div>
    </div>

    <div class="mt-3">
      <label>Display name</label>
      <input type="text" class="form-control" v-model="signUpForm.displayName" placeholder="Display name"
        :class="{ 'border-danger': signUpForm.errors.displayName }">
      <div class="msg-error" v-if="signUpForm.errors.displayName">{{ signUpForm.errors.displayName }}</div>
    </div>

    <!-- <div class="mt-3">
            <label>Email</label>
            <input class="form-control" v-model="signUpForm.email" type="text" placeholder="Email"
              :class="{ 'border-danger': signUpForm.errors.email }" />
            <div class="msg-error" v-if="signUpForm.errors.email">{{ signUpForm.errors.email }}</div>
          </div> -->

    <div class="mt-5">
      <button class="btn btn-success" style="width: 100%" @click="onSignUp()">
        <div v-if="signUpForm.isLoading" class="spinner-border spinner-border-sm" role="status">
          <span class="sr-only"></span>
        </div> Sign up
      </button>
    </div>
  </form>
  <div class="mt-4">
    <a href="javascript: void(0)" @click="$emit('return', 'signin')"><i class="fa-solid fa-arrow-left-long"></i> Back to
      login</a>
  </div>
</template>

<style lang="scss" scoped>
label {
  font-size: 0.8rem;
  margin-bottom: 2px;
}
</style>

<script>
export default {
  data() {
    return {
      signUpForm: this.getSignUpForm(),
    }
  },

  methods: {
    getSignUpForm() {
      return {
        isLoading: false,
        errors: {},
        displayName: '',
        loginValue: '',
        password: '',
        confirmPassword: ''
      }
    },

    async onSignUp() {
      this.signUpForm.isLoading = true;
      let res = await this.$aloop.account.auth.register({
        displayName: this.signUpForm.displayName,
        email: this.signUpForm.email,
        password: this.signUpForm.password,
        loginValue: this.signUpForm.loginValue,
        confirmPassword: this.signUpForm.confirmPassword
      }).call();

      this.signUpForm.isLoading = false;
      if (res.success) {
        this.$store.dispatch('confirmation/open', {
          title: 'Create successfully',
          type: 'info',
          message: 'Create account successfully, please check your email to active.',
          options: [
            {
              name: 'ok',
              label: 'OK',
              variant: 'primary'
            }
          ],
          events: {
            confirm: () => {
              this.$emit('return', 'signin');
            }
          }
        });
      } else {
        this.signUpForm.errors = res?.response?.errors || {};
      }
    },
  }
}
</script>